import React from "react";
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, WhatsappShareButton } from "react-share";
import "./styles.scss";

const longText = "Isn't it a great idea to formalize family and friends lending? Image the possibilities!";
const shortText = "Namma.co - a concept worth looking into"
const url = "https://namma.co?utm_source=Namma"
const hashTag = "#namma #askOnNamma"



const renderReactions = () => {
  return (
    <>
      <div>
        <p className="text-body-bold white">
          Share the wealth
        </p>
      </div>
      <div className="spacer-thin"></div>
      <div>
        <p className="text-body2 white">
          Sharing Namma with family/friends is a good idea!
        </p>
        <p className="text-body2 white">
          The more people that know about Namma. the better.
        </p>
      </div>

      <div className="spacer-thin"></div>
      <div className="text-body1 content-centered white">
        <span className="text-body1 white">
          Share on
        </span>
        <span>
          <EmailShareButton
            url={url}
            subject={shortText}
            body={longText}
          >
            <img src="/_Icons/email.svg" className="white-img" />
          </EmailShareButton>
        </span>
        <span >
          <WhatsappShareButton url={url}>
            <img src="/_Icons/whatsApp.svg" className="white-img" />
          </WhatsappShareButton>
        </span>
        <span >
          <LinkedinShareButton url={url}>
            <img src="/_Icons/linkedIn.svg" className="white-img" />
          </LinkedinShareButton>
        </span>
        <span>
          <FacebookShareButton
            url={url}
            quote={longText}
          >
            <img src="/_Icons/facebook.svg" className="white-img" />
          </FacebookShareButton>
        </span>
      </div>
    </>
  );
};

function HomePageShare() {
  return (
    <div className="container-basic">
      <div className="container-basic background-blue">
        {renderReactions()}
      </div>
    </div>

  );
}

export default HomePageShare;
